import * as React from "react";
import { createContext, useContext, useRef } from "react";
import type { VehicleHistoryUiState } from "../VehicleHistoryView";
import type { JobPageTab } from "../JobVehicleHistoryTabs";

// Kept above the routes so leaving a job (customer history, an invoice) and coming back restores its view.
export type JobViewMemory = {
  tabByJob: Record<string, JobPageTab>;
  uiStateByJob: Record<string, VehicleHistoryUiState>;
  scrollByView: Record<string, number>;
};

const createJobViewMemory = (): JobViewMemory => ({ tabByJob: {}, uiStateByJob: {}, scrollByView: {} });

const JobViewMemoryContext = createContext<JobViewMemory | null>(null);

export const JobViewMemoryProvider: React.FC = ({ children }) => {
  const memory = useRef(createJobViewMemory());
  return <JobViewMemoryContext.Provider value={memory.current}>{children}</JobViewMemoryContext.Provider>;
};

/** Without a provider (stories, isolated tests) each mount gets its own memory. */
export const useJobViewMemory = (): JobViewMemory => {
  const shared = useContext(JobViewMemoryContext);
  const own = useRef<JobViewMemory>();
  if (shared) return shared;
  if (!own.current) own.current = createJobViewMemory();
  return own.current;
};
